import { render, staticRenderFns } from "./PageSet.vue?vue&type=template&id=5fd613f7"
import script from "./PageSet.vue?vue&type=script&lang=js"
export * from "./PageSet.vue?vue&type=script&lang=js"
import style0 from "./PageSet.vue?vue&type=style&index=0&id=5fd613f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports